import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { CURRICULUM } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={CURRICULUM} id={id} />;
}

export const Route = createFileRoute("/_app/departments/curriculum/$id")({
  component: Edit,
});
